import React from "react";

const CompanyBrand = (props) => {

  if(props.type==="normal") {
    return (
      <React.Fragment>
        <div className="component_i">
          <img src={props.logo} alt="logo" />
        </div>
        <div className="component_ii">
          <h1>SecureTech</h1>
        </div>
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <div className="component_i">
          <img src={props.logo} alt="logo" />
        </div>
        <div className="component_ii">
          <h1>SecureTech<span>&reg;</span></h1>
          <h2>Shielding Your Digital World</h2>
        </div>
      </React.Fragment>
    );
  }
}

export default CompanyBrand;